import { useEffect } from 'react';
import { AlertTriangle, HardDrive } from 'lucide-react';
import { useStorageStore } from '../stores/storageStore';
import { cn } from '../utils/cn';

const StorageWarning = () => {
  const { calculateStorageSize, checkStorageLimit, isLoading, error } = useStorageStore();

  useEffect(() => {
    calculateStorageSize();
    
    // 5分ごとに更新
    const interval = setInterval(calculateStorageSize, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [calculateStorageSize]);

  const { isOverLimit, isNearLimit, usedPercentage, remainingMB } = checkStorageLimit();

  if (isLoading || error || (!isOverLimit && !isNearLimit)) {
    return null;
  }

  return (
    <div
      className={cn(
        "fixed bottom-4 right-4 max-w-sm p-4 rounded-lg shadow-lg",
        isOverLimit ? "bg-red-50" : "bg-yellow-50"
      )}
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          {isOverLimit ? (
            <AlertTriangle className="h-6 w-6 text-red-400" />
          ) : (
            <HardDrive className="h-6 w-6 text-yellow-400" />
          )}
        </div>
        <div className="ml-3">
          <h3 className={cn(
            "text-sm font-medium",
            isOverLimit ? "text-red-800" : "text-yellow-800"
          )}>
            {isOverLimit ? 'ストレージ容量を超過しています' : 'ストレージ容量が残り少なくなっています'}
          </h3>
          <div className={cn(
            "mt-2 text-sm",
            isOverLimit ? "text-red-700" : "text-yellow-700"
          )}>
            <p>使用量: {usedPercentage}%</p>
            <p>残り容量: {remainingMB}MB</p>
            <p className="mt-2">
              {isOverLimit
                ? '古いデータを削除して容量を確保してください。'
                : '不要なデータを削除することをお勧めします。'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorageWarning;